export default {"src":"/_next/static/media/RightArrow.2c582227.svg","height":33,"width":33};